import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.workstations;

// Axios instance with auth interceptor (token managed automatically)
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// Cached API wrapper - 5m TTL for workstation config data
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'workstations',
  defaultTtl: '5m',
  hashLargeSegments: true,
  emitMeta: true,
});

// =====================
// READS (cached)
// =====================

// get all workstation by local id
export const getWorkstationsByLocalId = async (localId: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllWorkstationsByLocalId/${localId}`));
};

// get all cajas by local id
export const getAllCajasByLocalId = async (localId: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllCajasByLocalId/${localId}`));
};

// /GetWorkstationsAvailableForPrinting/<int:local_id>
export const getWorkstationsAvailableForPrinting = async (localId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetWorkstationsAvailableForPrinting/${localId}`));
};

// GetWorkstationByWorkstationId
export const getWorkstationByWorkstationId = async (workstationId: number) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetWorkstationByWorkstationId/${workstationId}`));
};

// =====================
// MUTATIONS (no cache, invalidate after)
// =====================

// /UpdateWorkstationById/<int:workstation_id>
export const updateWorkstationById = async (workstationId: number, workstationData: any) => {
  const res = await retryWithBackoff(() => api.put(`/UpdateWorkstationById/${workstationId}`, workstationData));
  await cachedApi.clear();
  return res;
};

// Function to create a workstation
export const createWorkstation = async (workstationData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreateWorkstation', workstationData));
  await cachedApi.clear();
  return res;
};

export const deleteWorkstationById = async (workstationId: number) => {
  const res = await retryWithBackoff(() => api.delete(`/DeleteWorkstationById/${workstationId}`));
  await cachedApi.clear();
  return res;
};

export const createWorkstationFromListRegistration = async (workstationData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreateWorkstationFromListRegistration', workstationData));
  await cachedApi.clear();
  return res;
};

export const CreateWorkstationRegistration = async (workstationData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreateWorkstationRegistration', workstationData));
  await cachedApi.clear();
  return res;
};

export const DeleteWorkstationRegistration = async (code: string) => {
  const res = await retryWithBackoff(() => api.delete(`/DeleteWorkstationRegistration/${code}`));
  await cachedApi.clear();
  return res;
};